import React from 'react';
import clsx from 'clsx';
import type { MailboxProviderId } from 'fym-shared/src/music24/outreach/mailboxProviders';
import { TypedMemo } from '../../../common/types';
import { tileOf } from './mailboxGuideState';
/* eslint-disable css-modules/no-unused-class -- the tile classes are picked by key (styles[tile]) */
import styles from './ProviderMark.module.scss';

type MarkTile = 'gmail' | 'outlook' | 'microsoft365' | 'icloud' | 'yahoo' | 'zoho' | 'fastmail' | 'other';

/** The letters of each mark (design outreach-v2 p1 `.pm`). Brand logos are not used. */
const MARKS: Record<MarkTile, string> = {
  gmail: 'G',
  outlook: 'O',
  microsoft365: 'M',
  icloud: 'iC',
  yahoo: 'Y!',
  zoho: 'Z',
  fastmail: 'F',
  other: '@',
};

/** The mark of a provider: AOL shows the Yahoo mark, a web host and an unknown provider show "@". */
export function markTileOf(id: MailboxProviderId | null): MarkTile {
  const tile = tileOf(id);
  return tile !== null && tile in MARKS ? (tile as MarkTile) : 'other';
}

interface ProviderMarkProps {
  providerId: MailboxProviderId | null;
  /** The 40 px mark of a Mailboxes row (design q1); else the 34 px mark of a tile. */
  large?: boolean;
}

/** The short coloured mark of a mailbox provider (design outreach-v2 p1, q1). */
const ProviderMarkComponent: React.FC<ProviderMarkProps> = ({ providerId, large = false }) => {
  const tile = markTileOf(providerId);
  return (
    <span className={clsx(styles.mark, styles[tile], large && styles.large)} aria-hidden="true">
      {MARKS[tile]}
    </span>
  );
};

export const ProviderMark = TypedMemo(ProviderMarkComponent);
